module.exports = __webpack_public_path__ + "static/portico_04-5eb97abb5c28e7fb9af716a432a54ea4.jpg";